// noinspection DuplicatedCode

/**
 * Override to always use scrollbar for the collaboration page, because it contains (large) dropdowns.
 */

import {OverlayScrollbars} from 'overlayscrollbars';
import {getViewport, isElementInViewport, isTouchDevice} from 'surveylabJsAssets/common/_globals';
import _slider from 'surveylabJsAssets/page/_slider';

const widthThreshold = 992; // Don't use scollbar above that viewport width (assuming no dedicated scrolling zone is needed with that much space)
let scrollbar: OverlayScrollbars;
let isModalOpen: boolean = false;
let resizeTimer: ReturnType<typeof setTimeout> = null;

function enableScrollbar(): void {
    const containerMarginTop = parseInt($('#content').css('marginTop'));
    const containerHeight = getViewport().height - containerMarginTop;
    $('html').addClass('scrollbar'); // Add class to allow specific styling
    $('#content, #footer-main').wrapAll(
        $('<div></div>')
            .attr('id', 'scrollbar-wrapper')
            .attr('data-overlayscrollbars-initialize', '')
    );

    // Init scrollbar
    const $wrapperElement = $('#scrollbar-wrapper');
    $wrapperElement.css('marginTop', containerMarginTop + 'px');
    $wrapperElement.css('height', containerHeight + 'px');
    scrollbar = OverlayScrollbars($wrapperElement.get(0), {});

    // Make sticky table headers work with scrollbar
    scrollbar.on('scroll', function () {
        _slider.updateStickyTableHeaders();
    });
}

function needScrollbar(): boolean {
    const containsDropdowns = $('.survey-page-3000').length > 0 || $('.survey-page-3100').length > 0;
    const $lastNonFooterElement = $('#content > div').not('.footer-pushup').last();
    return !isScrollbarEnabled()
        && !isModalOpen
        && (!isElementInViewport($lastNonFooterElement.get(0)) || containsDropdowns)
        && getViewport().width < widthThreshold;
}

function destroyScrollbar(): void {
    if (isScrollbarEnabled()) {
        scrollbar.destroy();
        $('#content, #footer-main').unwrap();
        $('html').removeClass('scrollbar');
    }
}

export function isScrollbarEnabled(): boolean {
    return $('html').hasClass('scrollbar');
}

export function getScrollbarContainer(): JQuery {
    return $('#scrollbar-wrapper div[data-overlayscrollbars-viewport]');
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(window).on('load', function () {
        if (isTouchDevice()) {
            let viewportHeight = getViewport().height;

            if (needScrollbar()) {
                enableScrollbar();
            }

            $(this).on('resize', function () {
                // Use timeout/delay to avoid strange behaviour, because of resize event being triggered too often, @see https://stackoverflow.com/a/13244739
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    if (viewportHeight !== getViewport().height) {
                        // Adjust wrapper height when viewport height changes
                        const $wrapperElement = $('#scrollbar-wrapper');
                        const diff = getViewport().height - viewportHeight;
                        viewportHeight = getViewport().height;
                        const newHeight = parseInt($wrapperElement.css('height')) + diff;
                        $wrapperElement.css('height', newHeight + 'px');
                    }
                }, 200);
            });

            // Don't use scrollbar when modal is shown, because it's messy and leads to several issues
            $('body').on('show.bs.modal', function () {
                isModalOpen = true;
                destroyScrollbar();
            }).on('hide.bs.modal', function () {
                isModalOpen = false;
                if (needScrollbar()) {
                    enableScrollbar();
                    _slider.updateStickyTableHeaders();
                }
            });
        }
    });
}